<template>
  <div>
    <el-dialog title="报价详情" :visible.sync="showDrawer" :close="onClose" width="900px">
      <template #title>
        <h3 style="margin-right:10px">详情</h3>
      </template>
      <div style="text-align:right">
        <el-button v-if="isAddQuotedPrice" type="success" size="small" @click="onAdd">新增报价</el-button>
        <el-button type="primary" size="small" @click="onChat">发送消息</el-button>
      </div>
      <el-tabs v-model="tabsName">
        <el-tab-pane name="detail" label="任务详情">

          <el-card shadow="never" style="margin-bottom:10px">
            <el-descriptions class="margin-top" title="" :column="3" border>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-bangzhu"></i>
                  竞价状态
                </template>
                <el-tag v-if="status === 'bidding'" size="small" type="warning">竞价中</el-tag>
                <el-tag v-else-if="status === 'win'" size="small" type="success">中标</el-tag>
                <el-tag v-else-if="status === 'abort'" size="small">中止</el-tag>
                <el-tag v-else type="danger" size="small">失败</el-tag>
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-edit-outline"></i>
                  税点
                </template>
                {{ inquiryTask.taxRate }}
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-time"></i>
                  创建日期
                </template>
                {{ pltFormatter.date(inquiryTask.createTime) }}
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-edit-outline"></i>
                  备注
                </template>
                {{ inquiryTask.remark }}
              </el-descriptions-item>
            </el-descriptions>
          </el-card>

          <el-card shadow="never" v-if="addressList.length">
            <section v-for="(item, index) in addressList" :key="item.id">
              <el-divider v-if="index != 0"></el-divider>
              <el-descriptions style="margin-bottom:10px" :title="index == 0 ? '收发货地址' : ''" :colon="false" :column="2">
                <el-descriptions-item :span="2">
                  <div class="address">
                    <p class="badge success">起</p>
                    <div class="region">
                      <plt-dict-box namespace="region" id="fullArea" :value="item.fromAreaId"></plt-dict-box>
                      <p>{{ item.fromAddr }}</p>
                    </div>
                  </div>

                </el-descriptions-item>

                <el-descriptions-item :span="2">
                  <div class="address">
                    <p class="badge warning">终</p>
                    <div class="region">
                      <plt-dict-box namespace="region" id="fullArea" :value="item.toAreaId"></plt-dict-box>
                      <p>{{ item.toAddr }}</p>
                    </div>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item v-if="item.targetType">
                  <template slot="label">
                    <i class="el-icon-s-grid"></i>
                    产品名称
                  </template>
                  <template v-if="item.targetType">
                    <plt-dict-box style="color:#909399" namespace="target" id="type" :value="item.targetType"></plt-dict-box>
                  </template>
                  <template v-else>{{item.goodsName}}</template>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label" v-if="item.quantity">
                    <i class="el-icon-tickets"></i>
                    数量
                  </template>
                  <span style="color:#909399">{{item.quantity}}</span>
                </el-descriptions-item>

                <el-descriptions-item v-if="item.dimension">
                  <template slot="label">
                    <i class="el-icon-pie-chart"></i>
                    尺寸
                  </template>
                  <span style="color:#909399">{{item.dimension}}</span>

                </el-descriptions-item>
                <el-descriptions-item v-if="item.weight">
                  <template slot="label">
                    <i class="el-icon-files"></i>
                    重量
                  </template>
                  <span style="color:#909399">{{item.weight}}</span>
                </el-descriptions-item>

                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-time"></i>
                    装货日期
                  </template>
                  <span style="color:#909399"> {{ pltFormatter.date(item.planDate) }}</span>
                </el-descriptions-item>

              </el-descriptions>
            </section>
          </el-card>

        </el-tab-pane>

        <el-tab-pane label="报价记录" name="history">
          <el-table :data="quotes" border default-expand-all>
            <el-table-column type="expand">
              <template #default="{ row }">
                <div v-if="row.replies.length">
                  <h4 style="margin:10px">竞价反馈</h4>
                  <el-descriptions style="margin:0px 10px" v-for="item in row.replies" :key="item.replyId" class="margin-top" title="" :column="3">
                    <el-descriptions-item label="反馈时间">{{ item.createTime.replace("T", " ") }}</el-descriptions-item>
                    <el-descriptions-item label="反馈内容">{{ item.message }}</el-descriptions-item>
                  </el-descriptions>
                </div>
                <div v-else style="text-align:center">
                  暂无竞价反馈
                </div>
              </template>
            </el-table-column>
            <el-table-column label="报价编号" prop="quoteId" />
            <plt-table-dict-col label="运输方式" prop="transportMethod" namespace="logistic" id="transportMethod" />
            <plt-table-dict-col label="车辆类型" prop="vehicleId" namespace="logistic" id="vehicleType" />
            <el-table-column label="运费" prop="carriage" />
            <el-table-column label="配送费" prop="deliveryFee" />
            <el-table-column label="提货费" prop="pickUpFee" />
            <el-table-column label="总费用">
              <template #default="{ row }">
                {{ amountHandle(row) }}
              </template>
            </el-table-column>
            <el-table-column label="报价时间">
              <template #default="{ row }">
                {{ row.createTime.replace('T', ' ') }}
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" />

            <template #empty>
              <el-empty description="暂无数据"></el-empty>
            </template>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <add-quoted-price ref="addQuotedPriceRef" @onFinish="onFinish" />
      <chat ref="chatRef" />
    </el-dialog>
  </div>
</template>

<script>
import addQuotedPrice from "./add-quoted-price.vue";
import chat from "@/components/chat";

export default {
  components: { addQuotedPrice, chat },
  data() {
    return {
      showDrawer: false,
      inquiryTask: {},
      status: "",
      quotes: [],
      tabsName: "detail",
      bidId: "",
      isAddQuotedPrice: true,
      addressList: [],
    };
  },

  methods: {
    openDialog(id, isAddQuotedPrice = true) {
      this.tabsName = "detail";
      this.showDrawer = true;
      this.bidId = id;
      this.isAddQuotedPrice = isAddQuotedPrice;
      this.$nextTick(() => {
        this.getDetail(id);
      });
    },
    getDetail(bidId) {
      let url = "http://MID-OPERATE-LOGISTICS/messageService/logisticsInquiryTaskService/supplierQueryInquiryTaskDetail";
      this.invoke(url, { bidId })
        .then((res) => {
          this.inquiryTask = res.inquiryTask ? res.inquiryTask : {};
          this.status = res.biddingMember.status;
          this.quotes = res.quotes;
          this.addressList = res.routes;
        })
        .catch(() => {
          this.inquiryTask = {};
          this.status = "";
          this.quotes = [];
          this.addressList = [];
        });
    },

    amountHandle({ carriage, deliveryFee, pickUpFee }) {
      let total = Number(carriage + deliveryFee + pickUpFee).toFixed(2);

      return isNaN(total) ? "" : total;
    },

    onClose() {
      this.showDrawer = false;
      this.inquiryTask = {};
      this.status = "";
      this.quotes = [];
      this.addressList = [];
    },

    onAdd() {
      this.$refs["addQuotedPriceRef"].openDialog(this.bidId);
    },
    onFinish() {
      this.getDetail(this.bidId);
    },
    // 发生消息
    onChat() {
      let chatData = {
        id: this.bidId,
        toMember: "2",
        idKey: "bidId",
        chatUrl: "http://MID-OPERATE-LOGISTICS/messageService/inquiryChatService/queryChatsByBidId",
        sendMsgUrl: "http://MID-OPERATE-LOGISTICS/messageService/inquiryChatService/addInquiryChat",
      };
      this.$refs["chatRef"].init(chatData);
    },
  },
};
</script>
<style lang="scss" scoped>
i {
  padding-right: 4px;
}
/deep/.el-divider--horizontal {
  margin: 0 0 14px 0 !important;
}
.address {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // margin-left: 10px;

  .badge {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 6px;
    color: #fff;
    line-height: 22px;
    text-align: center;
  }

  .success {
    background: #67c23a;
  }

  .warning {
    background: #ff8800;
  }

  .region {
    span {
      font-size: 16px;
    }

    p {
      color: #909399;
    }
  }
}
</style>